import {
  getUrlToBlazeInsightsAPI,
  getBroadcastsAPI,
  createBroadcastAPI,
  updateBroadcastAPI,
  deleteBroadcastAPI,
  getDropdownsAPI,
  getGeneratedReportAPI,
  getBroadcastDropdownsInfoAPI,
  getAvailableReportsAPI,
  getReportRequestListAPI,
  exportByReportTypeAPI,
  syncInsightsPermissionsAPI,
} from '../api/insights'
import { addMessageCurry } from '../utils/api'
import {
  SETREPORT,
  SETREPORTLOADING,
  SET_FREQUENT_REPORTS,
  SET_REPORT_REQUEST_LIST,
} from '../types/insights'

export const redirectToBlazeInsights = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getUrlToBlazeInsightsAPI(), dispatch)
        .then((url) => {
          resolve(url)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getBroadcasts = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getBroadcastsAPI(), dispatch)
        .then((url) => {
          resolve(url)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const createBroadcast = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(createBroadcastAPI(data), dispatch)
        .then((url) => {
          resolve(url)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const updateBroadcast = (broadcastId, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateBroadcastAPI(broadcastId, data), dispatch)
        .then((url) => {
          resolve(url)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const deleteBroadcast = (broadcastId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(deleteBroadcastAPI(broadcastId), dispatch)
        .then((url) => {
          resolve(url)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getDropdowns = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getDropdownsAPI(), dispatch)
        .then((url) => {
          resolve(url)
        })
        .catch((err) => console.log(err))
    })
  }
}
export const setReportRequestList = (payload) => ({
  type: SET_REPORT_REQUEST_LIST,
  payload: payload,
})

export const getReportRequestList = () => {
  return (dispatch) => {
    return getReportRequestListAPI()
      .then((res) => {
        console.log(res.values)
        dispatch(setReportRequestList(res.values))
        return res.values
      })
      .catch(
        (err) => console.log(err),
        //addMessageCurry(dispatch)
      )
  }
}

export const getAvailableReports = () => {
  return (dispatch) => {
    return getAvailableReportsAPI()
      .then((res) => {
        //dispatch(availableReports(res))
        return res
      })
      .catch(
        (err) => console.log(err),
        //addMessageCurry(dispatch)
      )
  }
}

export const getBroadcastDropdownsInfo = () => {
  return (dispatch) => {
    return getBroadcastDropdownsInfoAPI()
      .then((res) => {
        //dispatch(availableReports(res))
        return res
      })
      .catch(
        (err) => console.log(err),
        //addMessageCurry(dispatch)
      )
  }
}

export const getGeneratedReport = (requestId) => {
  return (dispatch) => {
    let accessToken = JSON.parse(localStorage.getItem('session')).assetAccessToken
    return getGeneratedReportAPI(requestId, accessToken)
      .then((res) => {
        //dispatch(setReportRequestList(res.values))
        return res
      })
      .catch((err) => console.log(err))
  }
}

export function syncInsightsPermissions(employeeId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      syncInsightsPermissionsAPI(employeeId)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
}

export function exportByReportType(
  reportType,
  filterDate,
  startDate,
  endDate,
  shopIds,
  version,
  format,
) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      exportByReportTypeAPI(reportType, filterDate, startDate, endDate, shopIds, version, format)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
}



// WEBPACK FOOTER //
// ./src/actions/insights.js